import script from "./SetUpTwo.vue?vue&type=script&setup=true&lang=js"
export * from "./SetUpTwo.vue?vue&type=script&setup=true&lang=js"

import "./SetUpTwo.vue?vue&type=style&index=0&id=75cd1b8d&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75cd1b8d"]])

export default __exports__